var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.6913V18.3087C24 21.452 21.452 24 18.3087 24H5.6913C2.54799 24 0 21.452 0 18.3087V5.6913C0 2.54799 2.54799 0 5.6913 0H18.3087C21.452 0 24 2.54799 24 5.6913Z",
    fill: "#121D39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4305 3.8374H8.61308C6.05864 3.8374 3.98047 5.91558 3.98047 8.47051V15.288C3.98047 17.8424 6.05864 19.9211 8.61308 19.9211H15.4305C17.985 19.9211 20.0631 17.8429 20.0631 15.288V8.47002C20.0631 5.91558 17.985 3.8374 15.4305 3.8374ZM18.422 15.2875C18.422 16.937 17.0801 18.279 15.4305 18.279H8.61308C6.96353 18.279 5.62157 16.937 5.62157 15.2875V8.47002C5.62157 6.82047 6.96353 5.47851 8.61308 5.47851H15.4305C17.0801 5.47851 18.422 6.82047 18.422 8.47002V15.2875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0218 8.14404C9.96244 8.14404 8.28711 9.81939 8.28711 11.8787C8.28711 13.938 9.96244 15.6134 12.0218 15.6134C14.0811 15.6134 15.7564 13.938 15.7564 11.8787C15.7564 9.81939 14.0811 8.14404 12.0218 8.14404ZM12.0218 13.8964C10.909 13.8964 10.0041 12.9915 10.0041 11.8787C10.0041 10.766 10.909 9.86106 12.0218 9.86106C13.1345 9.86106 14.0394 10.766 14.0394 11.8787C14.0394 12.9915 13.134 13.8964 12.0218 13.8964Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2064 6.52441C15.5947 6.52441 15.0986 7.02052 15.0986 7.63222C15.0986 8.24391 15.5947 8.74001 16.2064 8.74001C16.8181 8.74001 17.3142 8.24391 17.3142 7.63222C17.3142 7.02052 16.8186 6.52441 16.2064 6.52441Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramContact);
export default __webpack_public_path__ + "static/media/instagram-contact.f48c3d9431a0f9e07b3063d1ddd9e103.svg";
export { ForwardRef as ReactComponent };